import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("ColibriToken");

export const userLogin = async (payload: any) => {
  try {
    const response = await $axios.post($api("login"), payload);
    return response;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const userLogout = async () => {
  return await $axios.get($api("logout"),{
     headers: {
      "Accept-Language": "az",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const user = async () => {
  const response = await $axios.get($api("user"), {
    headers: {
      "Accept-Language": "az",
      Authorization: `Bearer ${token}`,
    },
  });
  return response ? response?.data?.user : null;
};

export const userRegisterPyhsical = async (payload: any) => {
  return await $axios.post($api("registration_pyhsical"), payload);
};

export const userRegisterJuristical = async (payload: any) => {
  return await $axios.post($api("registration_juristical"), payload);
};

export const verifyUser = async (payload: any) => {
  return await $axios.post($api("verify_user"), payload);
};

export const resendOtp = async (payload: any) => {
  return await $axios.post($api("resend_otp"), payload);
};

export const resetPassword = async (payload: any) => {
  return await $axios.post($api("reset_password"), payload);
};
export const changePassword = async (otp_session: string, data: { password: string, password_confirmation: string }) => {
  try {
    const response = await $axios.put(
      $api("change_password", { otp_session }), 
      data  
    );
    return response;
  } catch (error) {
    throw error;
  }
};
